export default __webpack_public_path__ + "static/media/addOnBenefitshelp@2x.e014499f.png";